import React from "react";
import { useInView } from "react-intersection-observer";

const ServiceCard = ({ title, description, image }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <div
      ref={ref}
      className={`bg-gray-800 p-4 md:p-6 rounded-lg shadow-lg transform transition duration-500 hover:scale-105 hover:shadow-lg ${
        inView ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
      }`}
    >
      <img
        src={image}
        alt={title}
        className="w-full h-32 md:h-48 object-cover mb-4 rounded-md shadow-md"
      />
      <h3 className="text-xl md:text-2xl font-bold mb-4">{title}</h3>
      <p className="text-gray-400 text-sm md:text-base">{description}</p>
    </div>
  );
};

const Services = () => {
  return (
    <section id="services" className="py-10 md:py-20 bg-gray-900 text-white">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-10">Nossos Serviços</h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-10">
          <ServiceCard
            title="Sistemas Web Personalizados"
            description="Desenvolvemos sistemas personalizados para atender às necessidades específicas do seu negócio, incluindo lojas virtuais, controle de acesso e gestão de estoque."
            image="https://images.pexels.com/photos/265087/pexels-photo-265087.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
          />
          <ServiceCard
            title="Websites com Alta Performance"
            description="Criamos websites modernos e responsivos que fortalecem a presença online do seu negócio, utilizando tecnologias de ponta para garantir sites rápidos e seguros."
            image="https://images.pexels.com/photos/8284724/pexels-photo-8284724.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
          />
          <ServiceCard
            title="Aplicativos Móveis Sob Medida"
            description="Desenvolvemos aplicativos móveis intuitivos para Android e iOS, proporcionando uma experiência de usuário excepcional e funcionalidades avançadas."
            image="https://images.pexels.com/photos/1092644/pexels-photo-1092644.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
          />
          <ServiceCard
            title="Serviços Cloud"
            description="Oferecemos serviços em nuvem com alta performance e suporte 24 horas, garantindo que sua aplicação esteja sempre online e segura. Implementamos infraestrutura e plataformas escaláveis, adaptando-se às suas necessidades."
            //image="https://images.pexels.com/photos/3153201/pexels-photo-3153201.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            image="https://images.pexels.com/photos/1181354/pexels-photo-1181354.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
          />
        </div>
      </div>
    </section>
  );
};

export default Services;
